import React, { useEffect, useRef } from 'react'
import './ToggleButton.css'

type ToggleButtonProps = {
  id: string
  type: 'checkbox' | 'radio' | 'switch'
  name: string
  size?: 'sm' | 'md'
  checked?: boolean
  indeterminate?: boolean
  label?: string
  disabled?: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const ToggleButton: React.FC<ToggleButtonProps> = ({
  id,
  type,
  name,
  size = 'md',
  checked = false,
  indeterminate = false,
  label = '',
  disabled = false,
  onChange,
}) => {
  const inputRef = useRef<HTMLInputElement>(null)

  useEffect(() => {
    if (inputRef.current && type === 'checkbox') {
      inputRef.current.indeterminate = indeterminate
    }
  }, [indeterminate, type])

  const baseClass = type === 'switch' ? 'switch' : `${type}-custom`
  const className = `${baseClass} ${baseClass}-${size}`

  return (
    <div className="toggle-container">
      <input
        id={id}
        className={className}
        name={name}
        type={type === 'switch' ? 'checkbox' : type}
        checked={checked}
        disabled={disabled}
        ref={inputRef}
        onChange={onChange}
      />
      {label && (
        <label htmlFor={id} className={`${baseClass}-label`}>
          {label}
        </label>
      )}
    </div>
  )
}

export default ToggleButton
